module.exports = "images/noResult.7c85c54a.png";